/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Decoupling_One_LinerInputs */

const en_exp_decoupling_one_liner = /** @type {(inputs: Exp_Decoupling_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How far your heart rate drifted against your output from the first half to the second — like an engine that needs more fuel for the same speed once it runs hot.`)
};

const de_exp_decoupling_one_liner = /** @type {(inputs: Exp_Decoupling_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark dein Puls im Verhältnis zur Leistung von der ersten zur zweiten Hälfte gestiegen ist — wie ein Motor, der warm gelaufen mehr Sprit für dasselbe Tempo braucht.`)
};

/**
* | output |
* | --- |
* | "How far your heart rate drifted against your output from the first half to the second — like an engine that needs more fuel for the same speed once it runs hot." |
*
* @param {Exp_Decoupling_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_decoupling_one_liner = /** @type {((inputs?: Exp_Decoupling_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Decoupling_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_decoupling_one_liner(inputs)
	return de_exp_decoupling_one_liner(inputs)
});